app.Assessments = (
    function() {
        var assessments = {
            Failed: function () {
                //on document load refresh grid (mobile js requires this paradigm)
                app.page.components["FailedAssessmentsGrid"][0].refreshGrid();

                $(document).on("component-bind-view-mode-complete-FailedAssessmentsGrid", function()
                {
                    $(".reorderButton").on("click",
                        function () {
                            //Get the closest app id

                            //get the tr
                            var tr = $(this).closest("tr");

                            var id = $(tr).find('[name="Application.Index"]').val();
                            //submit the order
                            app.Assessments.ReorderAssessment(id);
                        });
                });

            },
            ReorderAssessment: function(appId) {
                var url = "/Admin/Assessment/ReOrder";
                var postData = { applicationId: appId };
                $.ajax({
                    type: "POST",
                    url: url,
                    data: postData,
                    success: function(data) {
                        toastr.success("Successfully ordered assessment.");
                        app.page.components["FailedAssessmentsGrid"][0].refreshGrid();
                    },
                    error: function(data) {
                        toastr.error(
                            "There was an error ordering the assessment. Please try again. Contact the WECAN technical team if the issue persists.");
                    }
                });
            }
        };
        return assessments;
    }()
);